import script from "./DeviceMeasurementsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceMeasurementsView.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceMeasurementsView.vue?vue&type=style&index=0&id=c7b04e16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7b04e16"]])

export default __exports__